export const ACTION_UPDATE_ADDRESS = "updateAddressAction";

export const updateAddressAction = (payload) => ({
  type: ACTION_UPDATE_ADDRESS,
  payload
});